export enum EVolumeUnit {
  lbs = 'lbs',
  mlbs = 'mlbs',
  mmlbs = 'mmlbs',
  ton = 'ton',
  kton = 'kton',
}

const volumeUnits: EVolumeUnit[] = [
  EVolumeUnit.lbs,
  EVolumeUnit.mlbs,
  EVolumeUnit.mmlbs,
  EVolumeUnit.ton,
  EVolumeUnit.kton,
];

export default volumeUnits;
